import angular from 'angular';

import InventoryGamesTabComponent from './inventory-games-tab-component';

export default angular.module('inventory-games-tab', []).component('inventoryGamesTab', new InventoryGamesTabComponent());



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/inventory-games-tab/inventory-games-tab-module.js